module.exports = __webpack_public_path__ + "img/167.53790d1d.png";